<!-- TV4-6337: an Airbnb card or system message is a note without a sender header. -->
<div *ngIf="isAirbnbNote" class="system-note">
  <span class="rule"></span>
  <span
    class="note"
    i18n-matTooltip
    matTooltip="Airbnb added this notification to the conversation. It is not a message from the guest."
    matTooltipPosition="above"
  >
    <i class="fab fa-airbnb text-danger"></i>
    <span>
      <span class="d-block font-weight-bold" i18n>Airbnb notification</span>
      <span [innerHtml]="message.messageTxt"></span>
      <span class="text-light">· {{ message.receivedOn | epoch : 'D-MMM-YYYY / H:mm A' }}</span>
    </span>
  </span>
  <span class="rule"></span>
</div>

<app-message-list-item-base
  *ngIf="!isAirbnbNote"
  #msg
  [message]="message"
  [inquiry]="inquiry"
  [collapsed]="collapsed"
  (collapse)="toggleCollapsing($event)"
  [currency]="currency"
  [viewPlainText]="viewPlainText"
  (editDraft)="editDraft.emit($event)"
  (aiGenerate)="aiGenerate.emit($event)"
  class=""
>
  <ng-container actions>
    <div class="d-flex ali-items-center gap-2">
      <span
        *ngIf="message.delivery_status"
        class="delivery-status"
        [attr.data-status]="message.delivery_status"
        [matTooltip]="
          message.readAt
            ? 'Read by guest · ' + (message.readAt | epoch : 'D-MMM-YYYY / H:mm A')
            : 'Delivery status: ' + message.delivery_status
        "
        matTooltipPosition="above"
      >
        {{ message.delivery_status }}
      </span>
      <a
        (click)="toggleCollapsing(!collapsed)"
        [matTooltip]="collapsed ? 'Expand message' : 'Collapse message'"
        matTooltipPosition="above"
        class="text-light d-inline-flex"
      >
        <i class="cs-icon text-md" [ngClass]="collapsed ? 'cs-icon-expand2' : 'cs-icon-collapse2'"></i>
      </a>

      <i class="fal fa-exclamation-triangle text-danger" *ngIf="isSpam" matTooltip="Spam"></i>
      <a
        i18n-matTooltip
        matTooltip="Create a new inquiry from this message"
        (click)="onCreateInquiry(message)"
        class="text-primary d-inline-flex"
        *ngIf="message.type !== messageTypes.Outbound"
      >
        <i class="cs-icon cs-icon-calendar-plus"></i>
      </a>
      <a
        i18n-matTooltip
        matTooltip="Message details"
        matTooltipPosition="above"
        (click)="onDetails(message, inquiry)"
        class="text-light d-inline-flex"
      >
        <i class="fal fa-info-circle"></i>
      </a>
      <a
        i18n-matTooltip
        matTooltip="Print Message"
        matTooltipPosition="above"
        (click)="onPrint()"
        class="text-light d-inline-flex"
      >
        <i class="fal fa-print"></i>
      </a>
      <a
        *ngIf="hasMove && !(1 | isReadonlyRole)"
        i18n-matTooltip
        matTooltip="Move to other inquiry"
        matTooltipPosition="above"
        (click)="onMove()"
        class="text-light d-inline-flex"
      >
        <i class="fal fa-share"></i>
      </a>
      <a
        i18n-matTooltip
        matTooltip="Delete"
        *ngIf="!(1 | isReadonlyRole) && !message.isSending"
        matTooltipPosition="above"
        (click)="onRemove()"
        class="text-light d-inline-flex"
      >
        <i class="cs-icon cs-icon-trash"></i>
      </a>
      <a
        (click)="viewPlainText = !viewPlainText"
        [class.active]="viewPlainText"
        [matTooltip]="viewPlainText ? 'View styled text' : 'View plain text'"
        matTooltipPosition="above"
        class="text-light d-inline-flex"
      >
        <i class="fal fa-file-alt"></i>
      </a>
    </div>
  </ng-container>
</app-message-list-item-base>

<!-- For Print -->
<div #printableMessageContent class="d-none">
  <ul style="list-style: none; padding: 0">
    <li *ngIf="messageDetails?.from"><b i18n>From:</b> {{ messageDetails?.from }}</li>
    <li *ngIf="messageDetails?.to"><b>To:</b> {{ messageDetails?.to }}</li>
    <li *ngIf="messageDetails?.cc"><b>CC:</b> {{ messageDetails?.cc }}</li>
    <li *ngIf="messageDetails?.bcc"><b>BCC:</b> {{ messageDetails?.bcc }}</li>
    <li *ngIf="messageDetails?.receivedOn"><b i18n>Date:</b> {{ messageDetails?.receivedOn | epoch }}</li>
    <li *ngIf="messageDetails?.subject"><b i18n>Subject:</b> {{ messageDetails?.subject }}</li>
    <li *ngIf="messageDetails?.id"><b>Id:</b> {{ messageDetails?.id }}</li>
  </ul>
  <div [innerHtml]="message.sanitizedMsgHtml"></div>
</div>
<ng-container *ngIf="incidentFromMessage$ | async as incident">
  <div class="d-flex flex-wrap align-items-center gap-3 mt-2">
    <div class="text-warning bg-secondary-warning px-2 py-1 rounded">
      Al has created an <a href="javascript:;" (click)="onIncident(incident)">incident</a>.
      <ng-container *ngIf="taskFromIncident$ | async as task">
        <ng-container i18n *ngIf="task.draft">Approve to generate a task from it.</ng-container>
        <ng-container i18n *ngIf="!task.draft">A task has been generated from it.</ng-container>
      </ng-container>
    </div>
    <div class="flex-fill"></div>
    <ng-container *ngIf="taskFromIncident$ | async as task">
      <button class="btn btn-secondary-info btn-sm" (click)="onViewTask(task)" *ngIf="!task.draft">
        <i class="cs-icon cs-icon-eye"></i>
        <ng-container i18n>View Task</ng-container>
      </button>
      <ng-container *ngIf="task.draft">
        <button class="btn btn-secondary-danger btn-sm" (click)="onRejectTask(task)">
          <i class="cs-icon cs-icon-times"></i>
          <ng-container i18n>Reject</ng-container>
        </button>
        <button class="btn btn-secondary-success btn-sm" (click)="onApproveTask(task)">
          <i class="cs-icon cs-icon-check"></i>
          <ng-container i18n>Approve & Create Task</ng-container>
        </button>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
